export enum AvatarSize {
  Table = 36,
  Network = 48,
  Profile = 64,
}
